import React from "react";
import CompanyForm from "./CompanyForm";

const Company = () => {
  return <CompanyForm />;
};

export default Company;
